import React from "react";
import "../styles.css";

export default function Prueba() {
  return (
    <div className="pagina-container">
      {/* Banner superior */}
      <header className="banner">
        <img src="/Logo-2-2427.png" className="img-derecha"  alt="Jocotepec | Gobierno Municipal" id="logo"/>
        <img src="/cimtra.jpg" alt="CIMTRA"className="img-centro" />
        <h1 className="titulo-banner">CIMTRA</h1>
        
      </header>

      {/* Cuerpo de la página */}
      <main className="contenido">
        <p>Bienvenido a la página principal.</p>
      </main>
    </div>
  );
}
